module.exports = __webpack_public_path__ + "static/img/recruitTwo.f792830.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageFour/recruitTwo.png
// module id = 7MgW
// module chunks = 0